module.exports = __webpack_public_path__ + "static/media/mountain1.c4287d59.jpg";